import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["MobilePublicationsFilters"] */ "/vercel/path0/src/components/filters/mobilePublicationsFilters.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PublicationsFilters"] */ "/vercel/path0/src/components/filters/publicationsFilters.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EntriesList"] */ "/vercel/path0/src/components/list/entriesList.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PublicationsSearchProvider"] */ "/vercel/path0/src/contexts/publicationsSearch.tsx");
